export default "__VITE_ASSET__BqTuX5q4__"